import type { PoliciesResponse } from '@/data/timeOffAccrual/types/common';
import type { DataResponse } from '@/data/types';
import Scheduling from '@/shared/api/scheduling';
import { parseAPIError } from '@/shared/redux/helpers/parseApiError';
import { createWiwAsyncThunk } from '@/store';

export interface UpdateUserPoliciesArgs {
  userId: string;
  policyIds: string[];
}

export const updateUserPolicies = createWiwAsyncThunk<DataResponse<PoliciesResponse>, UpdateUserPoliciesArgs>(
  'timeOff/policies/updateUserPolicies',
  async ({ userId, policyIds }, { rejectWithValue }) => {
    try {
      return await Scheduling.put({ policyIds }, `/timeoff/policies/user/${userId}`);
    } catch (error) {
      return rejectWithValue(parseAPIError(error));
    }
  },
);
